function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
  fill: "#150847"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.6272 22.4171C37.9258 22.4171 40.5999 25.0927 40.5999 28.3931V34.6244C40.5999 37.9249 37.9258 40.6004 34.6272 40.6004H20.6588C18.0455 40.6004 15.922 38.5019 15.8798 35.8972L15.8792 35.8181H32.4823C34.861 35.8181 36.7893 33.8887 36.7893 31.5088C36.7893 29.1288 34.861 27.1994 32.4823 27.1994H24.659C23.4715 27.1994 22.5088 26.2362 22.5088 25.0481V22.4171H34.6272ZM35.2813 15.4004C37.8946 15.4004 40.0181 17.4989 40.0603 20.1036L40.0609 20.1827H23.5175C21.1388 20.1827 19.2105 22.112 19.2105 24.492C19.2105 26.872 21.1388 28.8013 23.5175 28.8013H30.9227C32.3411 28.8013 33.491 29.9518 33.491 31.371V33.5836H21.3726C18.074 33.5836 15.3999 30.9081 15.3999 27.6077V21.3764C15.3999 18.0759 18.074 15.4004 21.3726 15.4004H35.2813Z",
  fill: "white"
});

function SvgVesrs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVesrs);
export default __webpack_public_path__ + "static/media/vesrs.ba882115.svg";
export { ForwardRef as ReactComponent };